import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Center } from '../../../../core/center/center.model';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatDialogConfig } from '@angular/material';
import { Subscription } from 'rxjs';
import { CenterService } from '../../../../core/center/center.service';
import { LayoutUtilsService , MessageType } from '../../../../core/_base/crud/utils/layout-utils.service';
import { UserEditComponent } from '../../user-management/users/user-edit/user-edit.component';
import { CenterEditComponent } from '../../training-center-management/center-edit/center-edit/center-edit.component';
import { VacanciesService } from '../../../../core/vacancy/vacancies.service';

import { OfficerDetailsComponent } from '../postings/officer-details/officer-details.component';
import { EditAccountDetailsComponent } from '../officer-account-details/edit-account-details/edit-account-details.component';
import Swal from 'sweetalert2';



// import { CenterEditComponent } from '../../../.center-edit/center-edit/center-edit.component';

@Component({
  selector: 'kt-update-requests',
  templateUrl: './update-requests.component.html',
  styleUrls: ['./update-requests.component.scss']
})
export class UpdateRequestsComponent implements OnInit {
  searchKey:string;
  searchFolio: string;

	// Table fields

  listData: MatTableDataSource<any>;

	displayedColumns = ['createdAt', 'folioNumber','requestDetails', 'actions'];

	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
	@ViewChild('sort1', {static: true}) sort: MatSort;
	// Filter fields
	@ViewChild('searchInput', {static: true}) searchInput: ElementRef;
	
	// Subscriptions
	private subscriptions: Subscription[] = [];

  constructor(
    private centerService: CenterService,
    private vacancyService: VacanciesService,
    private layoutUtilsService: LayoutUtilsService,

    private dialog: MatDialog
  ) { }

  ngOnInit() {
		this.getAllUpdateRequests()
	}

	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this.subscriptions.forEach(el => el.unsubscribe());
	}

	/**
	 * Load users list
	 */
	

	/** FILTRATION */
	filterConfiguration(): any {
		const filter: any = {};
		const searchText: string = this.searchInput.nativeElement.value;

		filter.lastName = searchText;

		filter.username = searchText;
		filter.email = searchText;
		filter.fillname = searchText;
		return filter;
	}

	/** ACTIONS */
	/**
	 * Delete user
	 *
	 * @param _item: User
	 */
	deleteUser(_item: Center) {
		const _title = 'Center Delete';
		const _description = 'Are you sure to permanently delete this center?';
		const _waitDesciption = 'Center is deleting...';
		const _deleteMessage = `Center has been deleted`;

		const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}

		//	this.store.dispatch(new UserDeleted({ id: _item.id }));
			this.layoutUtilsService.showActionNotification(_deleteMessage, MessageType.Delete);
		});
	}

	

	/* UI */
	/**
	 * Returns user roles string
	 *
	 * @param user: User
	 */

	/**
	 * Redirect to edit page
	 *
	 * @param id
	 */
	editUser(id) {
    
	}
	filterByFolio(){
		let folio = this.searchFolio
		if(folio != undefined){
			this.getAllUpdateRequests();

		}
	}
	getAllUpdateRequests(){
		this.vacancyService.getRequestedUpdate().subscribe(
			(list)=>{
				
        this.listData = new MatTableDataSource(list.records)
        
				this.listData.sort = this.sort
				this.listData.paginator = this.paginator
			
				
			}
			)

	}
	applyFilter(){
		
		this.listData.filter = this.searchKey.trim().toLowerCase();
  }
  
  onCreate(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "60%";
    //this.dialog.open(EditPostingComponent,dialogConfig )
  }
  onRepost(){
    
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "60%";
   // this.dialog.open(RepostOfficerComponent,dialogConfig )
  }
 onEdit(center,id) {
	
	const dialogConfig = new MatDialogConfig();
	dialogConfig.disableClose = true;
	dialogConfig.autoFocus = true;
	dialogConfig.width = "60%";
	dialogConfig.data= center;
	this.dialog.open(EditAccountDetailsComponent,dialogConfig)
	//this.router.navigate(['../users/edit', id], { relativeTo: this.activatedRoute });
}

onView(center,id) {
	
	const dialogConfig = new MatDialogConfig();
	dialogConfig.disableClose = true;
	dialogConfig.autoFocus = true;
	dialogConfig.width = "80%";
	dialogConfig.data= center;
	this.dialog.open(OfficerDetailsComponent,dialogConfig)
	//this.router.navigate(['../users/edit', id], { relativeTo: this.activatedRoute });
}

approve(id){

	Swal.fire({
		title: 'Are you sure you want to approve this update  ?',
		text: 'This process cannot be reversed',
		icon: 'warning',
		showCancelButton: true,
		confirmButtonText: 'Yes, I want to approve ',
		cancelButtonText: 'No, Cancel'
	}).then((result) => {
		if (result.value) {
			
		this.approveRequests({requestId: id})

		} else if (result.dismiss === Swal.DismissReason.cancel) {

		}
	})

}
reject(id){
	alert("rejecting"+ id)

}

approveRequests(data){
	this.vacancyService.approveRequestedUpdate(data).subscribe(
		(data)=>{
			
			Swal.fire(
				'Approved ',
				'Request successfully approved',
				'success'
			)
			this.getAllUpdateRequests();

		}, error => {
		
			let err = error.message
			//alert(JSON.stringify(err))
			Swal.fire(
				err,
				'Please fix and try again',
				'error'
			)
		}
		)

}
 
}
